import React, { useEffect, useState } from "react";
import {
  Checked,
  RedDeleteIcon,
  WarningIcon,
  WhiteDeleteIcon,
} from "../../../assets/images";
import { Label } from "reactstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import { CalenderIcon, PaperClipIcon, PlusIconCircle } from "../../Icon";
import { handleDate } from "../../../utils/commonFunctions";
import Select from "react-select";
import { components } from "react-select";
import { Checkbox, CircularAvatar } from "../../commons";
import { MasterEmailerList } from "../../../redux/masterData/masterTypes";
import MultipleUpload from "../../commons/Upload/MultipleUpload";
import { DropDownUserType } from "../../../screens/AdminReports/InvoiceReports/UsersInvoicingCount";
import ImageModal from "../../../screens/AdminReports/OpenItemsProgressReports/ImageModal";
import { AccordianJobDetailsType } from ".";
import "./style.scss";
import MultiUploadWithApi from "../../commons/UploadFileWithApi/MultiUploadWithApi";
import { RootState } from "../../../redux/rootReducers";
import { connect } from "react-redux";
import { MulitpleFileUploadData } from "../../../redux/clientSettings/clientSettingTypes";
import {
  multipleUploadFilesAction,
  resetMultipleFileUploadData,
  resetMultipleFileUploadError,
  resetMultipleFileUploadFetching,
  resetMultipleFileUploadSuccess,
} from "../../../redux/clientSettings";
import { StockUploadFilePayloadType } from "../../../commonTypes/clientSettingsTypes";
import MultiFilePreviewModal from "../../commons/MultiPreviewWithApi/MultiFilePreviewModal";

type FinacUserDropDownType = {
  value: number | null;
  label: string;
  image: string | undefined;
};

type ImageDetailsType = {
  imageUrl: string;
  downloadImage: string;
  fileType: string;
  finalFileName: string;
  updateBy: string;
  updatedAt: string;
};

type AppProps = {
  accordianJobDetails: AccordianJobDetailsType;
  accordianJobDetailsData: AccordianJobDetailsType[];
  setImageDetails: React.Dispatch<React.SetStateAction<ImageDetailsType>>;
  setShowFileUploadModal: any;
  token: string | null;
  uploadData: any;
  setUploadData: any;
  FileUploadSuccess: number | null;
  FileUploadFetching: boolean;
  FileUploadData: MulitpleFileUploadData[] | [];
  dispatchResetFileUploadSuccess: () => void;
  dispatchResetFileUploadError: () => void;
  dispatchResetFileUploadFetching: () => void;
  dispatchResetFileUploadData: () => void;
  dispatchUploadFilesAction: (data: StockUploadFilePayloadType) => void;
  renderFilesList: any;
  imageDetails: ImageDetailsType;
  resetImageUrl: any;
  handleEditFileList: (data: string) => void;
  handleAddMoreFarDetails: (index: number) => void;
  handleDeleteFarDetails: (index: number, rowIndex: number, item: any) => void;
  handleRemoveJobDetailsRow: (index: number, item: any) => void;
  handleJobDeatilsFormChange: (
    objKey: any,
    dataKey: any,
    value: any,
    index: number,
    rowIndex?: number
  ) => void;
  finalClientList: DropDownUserType[] | [];
  finacUsersList: FinacUserDropDownType[] | [];
  emailList?: MasterEmailerList[] | [];
  setClientOffset: React.Dispatch<React.SetStateAction<number>>;
  setEmailerOffset: React.Dispatch<React.SetStateAction<number>>;
  setfinacUsersOffset: React.Dispatch<React.SetStateAction<number>>;
  checkClientBottom?: () => void;
  setImageIndex: React.Dispatch<React.SetStateAction<number | null>>;
  imageIndex: number | null;
  setImagePreviewIndex: React.Dispatch<React.SetStateAction<number | null>>;
  setUploadImageData: React.Dispatch<React.SetStateAction<any>>;
  setEmailerText?: React.Dispatch<React.SetStateAction<string>>;
  setText?: React.Dispatch<React.SetStateAction<string>>;
  setClientText?: React.Dispatch<React.SetStateAction<string>>;
  imagePreviewIndex: number | null;
  setUsersDepartmentText: React.Dispatch<React.SetStateAction<string>>;
  setUsersDepartmentOffset: React.Dispatch<React.SetStateAction<number>>;
  finalUsersDepartmentList: any;
  usersDepartmentFetching: boolean;
  userType?: string;
  probationField?: string;
  isEdit?: boolean;
  finalFinacAssetList: any;
  checkUsersDepartmentBottom?: () => void;
  finacAssetApiCall: (index: number) => void;
  setFinacAssetText: React.Dispatch<React.SetStateAction<string>>;
  setFinacAssetOffset: React.Dispatch<React.SetStateAction<number>>;
  jobTitleListApiCall: (index: number) => void;
  finalJobTitleList: any;
  setJobTitleOffset: React.Dispatch<React.SetStateAction<number>>;
  setJobTitleText: React.Dispatch<React.SetStateAction<string>>;
};
const JobDetailsFormInput = ({
  accordianJobDetails,
  accordianJobDetailsData,
  handleRemoveJobDetailsRow,
  handleJobDeatilsFormChange,
  finalClientList,
  finacUsersList,
  emailList,
  setClientOffset,
  setEmailerOffset,
  setfinacUsersOffset,
  checkClientBottom,
  setImageDetails,
  setShowFileUploadModal,
  token,
  uploadData,
  setUploadData,
  FileUploadSuccess,
  FileUploadFetching,
  FileUploadData,
  dispatchResetFileUploadSuccess,
  dispatchResetFileUploadError,
  dispatchResetFileUploadData,
  dispatchResetFileUploadFetching,
  dispatchUploadFilesAction,
  imageIndex,
  setImageIndex,
  setImagePreviewIndex,
  setUploadImageData,
  resetImageUrl,
  handleEditFileList,
  renderFilesList,
  imageDetails,
  setEmailerText,
  setText,
  setClientText,
  imagePreviewIndex,
  handleAddMoreFarDetails,
  handleDeleteFarDetails,
  finalFinacAssetList,
  setUsersDepartmentText,
  setUsersDepartmentOffset,
  finalUsersDepartmentList,
  checkUsersDepartmentBottom,
  usersDepartmentFetching,
  userType,
  finacAssetApiCall,
  setFinacAssetText,
  setFinacAssetOffset,
  probationField,
  isEdit,
  jobTitleListApiCall,
  finalJobTitleList,
  setJobTitleOffset,
  setJobTitleText,
}: AppProps) => {
  let containerName: any = process.env.REACT_APP_USER_CONTAINER_NAME;
  const [modal, toggleModal] = useState<boolean>(false);
  const [showImagePreview, setShowImagePreview] = useState<boolean>(false);
  const [data, setData] = useState<any>(
    JSON.parse(JSON.stringify(accordianJobDetails))
  );
  const [showForm, setShowForm] = useState(true);
  const [defaultAddress, setDefaultAddress] = useState(false);
  const [uploadSuccessArray, setUploadSuccessArray] = useState<any>([]);

  useEffect(() => {
    dispatchResetFileUploadFetching();
    dispatchResetFileUploadData();
    dispatchResetFileUploadSuccess();
    dispatchResetFileUploadError();
  }, []);
  useEffect(() => {
    let arr: any[] = [];
    accordianJobDetailsData?.map((item: any, index: number) => {
      arr.push({ ...item });
    });
    setData([...arr]);
  }, [accordianJobDetailsData]);  

  const checkBottom = (e: any) => {
    setfinacUsersOffset((prv: any) => prv + 20);
  };

  const checkFixedAssetBottom = (e: any) => {
    setFinacAssetOffset((prv: any) => prv + 50);
  };

  const checkJobTitleBottom = (e: any) => {
    setJobTitleOffset((prv: any) => prv + 20);
  };

  const handleUploadFile = (data: any, fileData: any) => {
    // setImageDetails(data);
    setShowFileUploadModal(false);

    // setUploadData((prevUploadData: any) => [...prevUploadData, data]);
    setUploadImageData((prevUploadData: any) => [...prevUploadData, data]);
  };

  const emailerOption = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label}
            image={data?.image && data?.image}
          />
          {data?.label}
        </div>
      </components.Option>
    );
  };

  // useEffect(()=>{
  //   setUploadData([])
  // },[uploadData,imageIndex])
  const showUploadModal = () => {
    setUploadImageData([]);
    toggleModal(!modal);
    if (modal) setImageIndex(null);
  };
  const handleFileChange = (file: any) => {
    const finalData = {
      token,
      fileData: file,
    };
    return dispatchUploadFilesAction(finalData);
  };
  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label.split("%")[0]}
            image={data?.image && data?.image}
          />
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label.split("%")[0]}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label.split("%")[1]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  };

  const renderJobDetails = () => {
    let arr: any[] = [];
    data?.length &&
      data?.map((item: any, index: number) => {
        const hasEndDate = item?.reporting_details?.far_assigned_details?.some((date: any) => date?.far_start_date && !date?.far_end_date)
        arr.push(
          <div
            className="col-md-12 mt-2 mb-2 d-flex justify-content-between form-control"
            style={{
              height: "40px",
              border: "1px solid",
              backgroundColor: "#5c6177",
            }}
          >
            <div>
              <span
                style={{ color: "white" }}
                onClick={() => {
                  setShowForm(!showForm);
                  item.isOpen = !item?.isOpen;
                }}
              >
                {item["isOpen"] ? (
                  <i className="las la-angle-up pointer"></i>
                ) : (
                  <i className="las la-angle-down pointer"></i>
                )}
              </span>
              <span
                className="ml-2"
                style={{ fontSize: "12px", color: "white" }}
              >
                Job Details{" "}
                {`${index + 1 < 10 ? "0" + (index + 1) : index + 1}`}
              </span>
            </div>
            <div>
              {true && accordianJobDetailsData?.length > 1 ? (
                <span>
                  <img
                    className="pointer"
                    src={WhiteDeleteIcon}
                    onClick={() => handleRemoveJobDetailsRow(index,item)}
                  />{" "}
                  <span style={{ fontSize: "12px", color: "white" }}>
                    Delete Job Details
                  </span>
                </span>
              ) : null}
            </div>
          </div>
        );
        if (item?.hasOwnProperty("isOpen") && item?.isOpen === true) {
          arr.push(
            <div className="pl-4 pt-2">
              <div className="d-flex mt-3 mb-3">
                <div
                  className={`checkboxContainer d-flex justify-content-center align-item-center pointer checkbox`}
                  onClick={() =>
                    handleJobDeatilsFormChange(
                      "empty",
                      "is_default",
                      true,
                      index
                    )
                  }
                  style={{ border: item["is_default"] ? "none" : "" }}
                >
                  {item["is_default"] && (
                    <img src={Checked} alt="Checkbox Checked" />
                  )}
                </div>
                <small
                  className="ml-2"
                  style={{
                    fontSize: "14px",
                    color: "#262a44",
                    marginTop: "-3px",
                  }}
                >
                  Make this as Default Job
                </small>
              </div>
              <h6 style={{ marginBottom: "8px" }}>JOB INFO</h6>
              <div className="row">
                <div className="col-md-3">
                  <label htmlFor="employeeId">Employee ID</label>
                  <input
                    type="text"
                    className="form-control"
                    name="employee_id"
                    value={
                      item["job_info"]["employee_id"]
                        ? item["job_info"]["employee_id"]
                        : ""
                    }
                    onChange={(e) =>
                      handleJobDeatilsFormChange(
                        "job_info",
                        "employee_id",
                        e.target.value,
                        index
                      )
                    }
                  />
                </div>
                <div className="col-md-3">
                  <label htmlFor="department">Department</label>
                  <Select
                    options={ [{label: "Select..", value:null}, ...finalUsersDepartmentList,]}
                    value={item["job_info"]["department"]}
                    onChange={(e) =>
                      handleJobDeatilsFormChange(
                        "job_info",
                        "department",
                        e,
                        index
                      )
                    }
                    isSearchable={true}
                    isLoading={usersDepartmentFetching}
                    onMenuClose={() => setUsersDepartmentOffset?.(0)}
                    onMenuScrollToBottom={checkUsersDepartmentBottom}
                    onInputChange={(e) => {
                      setUsersDepartmentText?.(e);
                      setUsersDepartmentOffset?.(0);
                    }}
                  />
                </div>
                <div className="col-md-3">
                  <label htmlFor="jobTitle">Job Title</label>
                  <Select
                    options={[{ label: "Select..", value: null }, ...finalJobTitleList,]}
                    value={item["job_info"]["designation"]}
                    onChange={(e) =>
                      handleJobDeatilsFormChange(
                        "job_info",
                        "designation",
                        e,
                        index
                      )
                    }
                    isSearchable={true}
                    // isLoading={jobTitleFetching}
                    onMenuOpen={() => jobTitleListApiCall(index)}
                    onMenuScrollToBottom={checkJobTitleBottom}
                    onInputChange={(e) => {
                      setJobTitleText?.(e);
                      setJobTitleOffset?.(0);
                    }}
                  />
                </div>
                <div className="col-md-3">
                  <label htmlFor="total_experience">Total Experience</label>
                  <input
                    type="text"
                    className="form-control"
                    name="total_experience"
                    value={item["job_info"]["total_experience"]}
                    onChange={(e) =>
                      handleJobDeatilsFormChange(
                        "job_info",
                        "total_experience",
                        e.target.value,
                        index
                      )
                    }
                  />
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-3">
                  <label htmlFor="dateOfBirth">Start Date</label>
                  <div className="d-flex flex-row position-relative">
                    <div className="date-picker-wraper mr-0 w-100">
                      <Label className="mr-0 w-100">
                        <DatePicker
                          dateFormat="dd-MM-yyyy"
                          selected={
                            item["job_info"]["start_date"]
                              ? new Date(
                                  moment(
                                    `${item["job_info"]["start_date"]}T00:00:00`,
                                    "YYYY-MM-DD"
                                  ).format("YYYY-MM-DD[T]HH:mm:ss")
                                )
                              : null
                          }
                          onChange={(e: any) => {
                            handleJobDeatilsFormChange?.(
                              "job_info",
                              "start_date",
                              moment(e).format("YYYY-MM-DD"),
                              index
                            );
                          }}
                          fixedHeight
                          showMonthDropdown
                          showYearDropdown
                          //   disabled={!isEdit}
                          name="date_of_birth"
                          placeholderText="Select"
                          className="form-control"
                        />
                        <span
                          className="calender-icon"
                          style={{
                            right: "20px",
                            top: "10px",
                            cursor: "pointer",
                          }}
                        >
                          <CalenderIcon />
                        </span>
                      </Label>
                    </div>
                  </div>
                </div>

                <div className="col-md-3">
                  <label htmlFor="end_date">End Date</label>
                  <div className="d-flex flex-row position-relative">
                    <div className="date-picker-wraper mr-0 w-100">
                      <Label className="mr-0 w-100">
                        <DatePicker
                          dateFormat="dd-MM-yyyy"
                          selected={
                            item["job_info"]["end_date"]
                              ? new Date(
                                  moment(
                                    `${item["job_info"]["end_date"]}T00:00:00`,
                                    "YYYY-MM-DD"
                                  ).format("YYYY-MM-DD[T]HH:mm:ss")
                                )
                              : null
                          }
                          onChange={(e: any) => {
                            handleJobDeatilsFormChange?.(
                              "job_info",
                              "end_date",
                              moment(e).format("YYYY-MM-DD"),
                              index
                            );
                          }}
                          fixedHeight
                          showMonthDropdown
                          showYearDropdown
                          placeholderText="Select"
                          className="form-control"
                        />
                        <span
                          className="calender-icon"
                          style={{
                            right: "20px",
                            top: "10px",
                            cursor: "pointer",
                          }}
                        >
                          <CalenderIcon />
                        </span>
                      </Label>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <label htmlFor="reJoinDate">Re-Join Date</label>
                  <div className="d-flex flex-row position-relative">
                    <div className="date-picker-wraper mr-0 w-100">
                      <Label className="mr-0 w-100">
                        <DatePicker
                          dateFormat="dd-MM-yyyy"
                          selected={
                            item["job_info"]["rejoin_date"]
                              ? new Date(
                                  moment(
                                    `${item["job_info"]["rejoin_date"]}T00:00:00`,
                                    "YYYY-MM-DD"
                                  ).format("YYYY-MM-DD[T]HH:mm:ss")
                                )
                              : null
                          }
                          onChange={(e: any) => {
                            handleJobDeatilsFormChange?.(
                              "job_info",
                              "rejoin_date",
                              moment(e).format("YYYY-MM-DD"),
                              index
                            );
                          }}
                          fixedHeight
                          showMonthDropdown
                          showYearDropdown
                          //   disabled={!isEdit}
                          // name="date_of_birth"
                          placeholderText="Select"
                          className="form-control"
                        />
                        <span
                          className="calender-icon"
                          style={{
                            right: "20px",
                            top: "10px",
                            cursor: "pointer",
                          }}
                        >
                          <CalenderIcon />
                        </span>
                      </Label>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <label htmlFor="dateOfNotice">Date of Notice</label>
                  <div className="d-flex flex-row position-relative">
                    <div className="date-picker-wraper mr-0 w-100">
                      <Label className="mr-0 w-100">
                        <DatePicker
                          dateFormat="dd-MM-yyyy"
                          selected={
                            item["job_info"]["date_of_notice"]
                              ? new Date(
                                  moment(
                                    `${item["job_info"]["date_of_notice"]}T00:00:00`,
                                    "YYYY-MM-DD"
                                  ).format("YYYY-MM-DD[T]HH:mm:ss")
                                )
                              : null
                          }
                          onChange={(e: any) => {
                            handleJobDeatilsFormChange?.(
                              "job_info",
                              "date_of_notice",
                              moment(e).format("YYYY-MM-DD"),
                              index
                            );
                          }}
                          fixedHeight
                          showMonthDropdown
                          showYearDropdown
                          //   disabled={!isEdit}
                          // name="date_of_birth"
                          placeholderText="Select"
                          className="form-control"
                        />
                        <span
                          className="calender-icon"
                          style={{
                            right: "20px",
                            top: "10px",
                            cursor: "pointer",
                          }}
                        >
                          <CalenderIcon />
                        </span>
                      </Label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-3">
                  <label htmlFor="dateOfRelieve">Date of Relieve</label>
                  <div className="d-flex flex-row position-relative">
                    <div className="date-picker-wraper mr-0 w-100">
                      <Label className="mr-0 w-100">
                        <DatePicker
                          dateFormat="dd-MM-yyyy"
                          selected={
                            item["job_info"]["date_of_relieve"]
                              ? new Date(
                                  moment(
                                    `${item["job_info"]["date_of_relieve"]}T00:00:00`,
                                    "YYYY-MM-DD"
                                  ).format("YYYY-MM-DD[T]HH:mm:ss")
                                )
                              : null
                          }
                          onChange={(e: any) => {
                            handleJobDeatilsFormChange?.(
                              "job_info",
                              "date_of_relieve",
                              moment(e).format("YYYY-MM-DD"),
                              index
                            );
                          }}
                          fixedHeight
                          showMonthDropdown
                          showYearDropdown
                          //   disabled={!isEdit}
                          // name="date_of_birth"
                          placeholderText="Select"
                          className="form-control"
                        />
                        <span
                          className="calender-icon"
                          style={{
                            right: "20px",
                            top: "10px",
                            cursor: "pointer",
                          }}
                        >
                          <CalenderIcon />
                        </span>
                      </Label>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <label htmlFor="dateOfConformation">
                    Date of Confirmation{" "}
                  </label>
                  <div className="d-flex flex-row position-relative">
                    <div className="date-picker-wraper mr-0 w-100">
                      <Label className="mr-0 w-100">
                        <DatePicker
                          dateFormat="dd-MM-yyyy"
                          selected={
                            item["job_info"]["date_of_conformation"]
                              ? new Date(
                                  moment(
                                    `${item["job_info"]["date_of_conformation"]}T00:00:00`,
                                    "YYYY-MM-DD"
                                  ).format("YYYY-MM-DD[T]HH:mm:ss")
                                )
                              : null
                          }
                          onChange={(e: any) => {
                            handleJobDeatilsFormChange?.(
                              "job_info",
                              "date_of_conformation",
                              moment(e).format("YYYY-MM-DD"),
                              index
                            );
                          }}
                          fixedHeight
                          showMonthDropdown
                          showYearDropdown
                          //   disabled={!isEdit}
                          // name="date_of_birth"
                          placeholderText="Select"
                          className="form-control"
                        />
                        <span
                          className="calender-icon"
                          style={{
                            right: "20px",
                            top: "10px",
                            cursor: "pointer",
                          }}
                        >
                          <CalenderIcon />
                        </span>
                      </Label>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <label htmlFor="employeeId">Client</label>
                  <Select
                    options={finalClientList}
                    value={item["job_info"]["show_client"]}
                    onChange={(e) =>
                      handleJobDeatilsFormChange("job_info", "client", e, index)
                    }
                    isSearchable={true}
                    components={{ Option }}
                    // isLoading={clientFetching}
                    onMenuClose={() => setClientOffset?.(0)}
                    onMenuScrollToBottom={checkClientBottom}
                    onInputChange={(e) => {
                      setClientText?.(e);
                      setClientOffset?.(0);
                    }}
                    // isDisabled={item?.reporting_details?.far_assigned_details?.some((date: any) => date?.far_start_date && !date?.far_end_date) ?? false}
                    isDisabled={hasEndDate}
                  />
                </div>

                <div className="col-md-3">
                  <label className="mb-1">Emailer Setting</label>
                  <Select
                    className="dropdown"
                    placeholder={
                      <div style={{ color: "hsl(0, 0%, 20%)" }}>Select..</div>
                    }
                    value={
                      item["show_emailer_settings"][0]?.label
                        ? item["show_emailer_settings"]
                        : []
                    }
                    options={emailList}
                    onChange={(e) =>
                      handleJobDeatilsFormChange(
                        "",
                        "emailer_settings",
                        e,
                        index
                      )
                    }
                    isMulti
                    isClearable
                    onMenuClose={() => setEmailerOffset(0)}
                    // components={{emailerOption}}
                    // isLoading={fetching && accessToOthersText?.length > 0}
                    // isSearchable={true}
                    onMenuScrollToBottom={(e: any) =>
                      setEmailerOffset((prev: number) => prev + 20)
                    }
                    onInputChange={(e: string) => {
                      setEmailerText?.(e);
                      setEmailerOffset?.(0);
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <label htmlFor="gender">Reporting Person</label>
                  <Select
                    className="dropdown"
                    placeholder={"Search User"}
                    value={item["reporting_details"]["show_reporting_person"]}
                    options={finacUsersList}
                    onChange={(e) =>
                      handleJobDeatilsFormChange(
                        "reporting_details",
                        "reporting_person",
                        e,
                        index
                      )
                    }
                    // isMulti
                    // isClearable
                    components={{ Option }}
                    // isLoading={userFetching}
                    onMenuClose={() => setfinacUsersOffset(0)}
                    isSearchable={true}
                    onMenuScrollToBottom={(e: any) => checkBottom(e)}
                    onInputChange={(e: any) => {
                      setText?.(e);
                      setfinacUsersOffset?.(0);
                    }}
                  />
                </div>
                <div className="col-md-3">
                  <label htmlFor="gender">Coach</label>

                  <Select<any, false>
                    inputProps={{ autoComplete: "nope" }}
                    placeholder={"Select Coach"}
                    options={finacUsersList}
                    value={item["reporting_details"]["show_coach"]}
                    components={{ Option }}
                    // isLoading={userFetching}
                    onMenuClose={() => setfinacUsersOffset(0)}
                    isSearchable={true}
                    onMenuScrollToBottom={(e: any) => checkBottom(e)}
                    onInputChange={(e: any) => {
                      setText?.(e);
                      setfinacUsersOffset(0);
                    }}
                    onChange={(e) =>
                      handleJobDeatilsFormChange(
                        "reporting_details",
                        "coach",
                        e,
                        index
                      )
                    }
                  />
                </div>
                {((item["job_info"]["probation_end_date"] &&
                  isEdit &&
                  probationField?.length) ||
                  probationField === "Probation") && (
                  <div className="col-md-3">
                    <label htmlFor="end_date">Probation End Date</label>
                    <div className="d-flex flex-row position-relative">
                      <div className="date-picker-wraper mr-0 w-100">
                        <Label className="mr-0 w-100">
                          <DatePicker
                            dateFormat="dd-MM-yyyy"
                            selected={
                              item["job_info"]["probation_end_date"]
                                ? new Date(
                                    moment(
                                      `${item["job_info"]["probation_end_date"]}T00:00:00`,
                                      "YYYY-MM-DD"
                                    ).format("YYYY-MM-DD[T]HH:mm:ss")
                                  )
                                : null
                            }
                            onChange={(e: any) => {
                              handleJobDeatilsFormChange?.(
                                "job_info",
                                "probation_end_date",
                                moment(e).format("YYYY-MM-DD"),
                                index
                              );
                            }}
                            fixedHeight
                            showMonthDropdown
                            showYearDropdown
                            placeholderText="Select"
                            className="form-control"
                            disabled={true}
                          />
                          <span
                            className="calender-icon"
                            style={{
                              right: "20px",
                              top: "10px",
                              cursor: "pointer",
                            }}
                          >
                            <CalenderIcon />
                          </span>
                        </Label>
                      </div>
                    </div>
                  </div>
                )}

                <div className="col-md-4 mt-1 mb-3 pt-3 d-flex">
                  <button
                    className="btn btn-outline"
                    onClick={() => {
                      showUploadModal();
                      setImageIndex(index);
                    }}
                  >
                    + Upload File
                  </button>

                  <div
                    className="pointer position-relative ml-3"
                    style={{ cursor: "pointer" }}
                  >
                    {item?.file_attachment?.length ? (
                      <span
                        id="Popover1"
                        onClick={() => {
                          setShowImagePreview(true);
                          setImagePreviewIndex(index);
                          // setImageIndex(index)
                        }}
                      >
                        <PaperClipIcon />
                        <span
                          className="badge count-badge"
                          style={{ left: "11px" }}
                        >
                          {item?.file_attachment?.length}
                        </span>
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
              {/* <div className="row mt-2">
               
              </div> */}

              <h6 style={{ marginBottom: "8px" }} className="mt-3">
                ASSET DETAILS
              </h6>
              <div className="form-group mt-2" style={{ marginTop: "15px" }}>
                {item["reporting_details"]["far_assigned_details"]?.map(
                  (farItem: any, rowIndex: number) => {
                    return (
                      <div className="row">
                        <div className="col-md-5">
                          <label htmlFor="lastName">
                            IT Assets Assigned{" "}
                            {(farItem?.far_it_assets_assigned?.value || farItem?.far_start_date) &&(
                              <span className="color-red">*</span>
                            )}
                          </label>
                          {/* commented for future use  */}
                          {/* <textarea
                       className="form-control"
                       name="it_assets_assigned"
                       style={{ height: "115px", resize: "none" }}
                       value={item["reporting_details"]["it_assets_assigned"]}
                       onChange={(e: any) => {
                         handleJobDeatilsFormChange(
                           "reporting_details",
                           "it_assets_assigned",
                           e.target.value,
                           index
                         );
                       }}
                     /> */}

                          <Select
                            className="dropdown"
                            placeholder={"Search User"}
                            value={farItem?.far_it_assets_assigned}
                            options={finalFinacAssetList}
                            isDisabled={!item["job_info"]["show_client"]?.value}
                            onChange={(e) =>
                              handleJobDeatilsFormChange(
                                "reporting_details",
                                "far_it_assets_assigned",
                                e,
                                index,
                                rowIndex
                              )
                            }
                            onMenuOpen={() => finacAssetApiCall(index)}
                            isSearchable={true}
                            onMenuScrollToBottom={(e: any) =>
                              checkFixedAssetBottom(e)
                            }
                            onInputChange={(e: any) => {
                              setFinacAssetText?.(e);
                              setFinacAssetOffset?.(0);
                            }}
                          />
                        </div>
                        <div className="col-md-3">
                          <label htmlFor="dateOfConformation">
                            Start Date
                            {(farItem?.far_it_assets_assigned?.value || farItem?.far_start_date) && (
                              <span className="color-red">*</span>
                            )}
                          </label>
                          <div className="d-flex flex-row position-relative">
                            <div className="date-picker-wraper mr-0 w-100">
                              <Label className="mr-0 w-100">
                                <DatePicker
                                  dateFormat="dd-MM-yyyy"
                                  disabled={
                                    !item["job_info"]["show_client"]?.value
                                  }
                                  selected={
                                    farItem?.far_start_date
                                      ? new Date(
                                          moment(
                                            `${farItem?.far_start_date}T00:00:00`,
                                            "YYYY-MM-DD"
                                          ).format("YYYY-MM-DD[T]HH:mm:ss")
                                        )
                                      : null
                                  }
                                  onChange={(e: any) => {
                                    if (e) {
                                      handleJobDeatilsFormChange?.(
                                        "reporting_details",
                                        "far_start_date",
                                        moment(e).format("YYYY-MM-DD"),
                                        index,
                                        rowIndex
                                      );
                                    }
                                  }}
                                  fixedHeight
                                  showMonthDropdown
                                  showYearDropdown
                                  placeholderText="Select"
                                  className="form-control"
                                />
                                <span
                                  className="calender-icon"
                                  style={{
                                    right: "20px",
                                    top: "10px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <CalenderIcon />
                                </span>
                              </Label>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <label htmlFor="dateOfConformation">End Date </label>
                          <div className="d-flex flex-row position-relative">
                            <div className="date-picker-wraper mr-0 w-100">
                              <Label className="mr-0 w-100">
                                <DatePicker
                                  dateFormat="dd-MM-yyyy"
                                  disabled={
                                    !item["job_info"]["show_client"]?.value
                                  }
                                  selected={
                                    farItem?.far_end_date
                                      ? new Date(
                                          moment(
                                            `${farItem?.far_end_date}T00:00:00`,
                                            "YYYY-MM-DD"
                                          ).format("YYYY-MM-DD[T]HH:mm:ss")
                                        )
                                      : null
                                  }
                                  onChange={(e: any) => {
                                    if (e) {
                                      handleJobDeatilsFormChange?.(
                                        "reporting_details",
                                        "far_end_date",
                                        moment(e).format("YYYY-MM-DD"),
                                        index,
                                        rowIndex
                                      );
                                    }
                                  }}
                                  fixedHeight
                                  showMonthDropdown
                                  showYearDropdown
                                  placeholderText="Select"
                                  className="form-control"
                                />
                                <span
                                  className="calender-icon"
                                  style={{
                                    right: "20px",
                                    top: "10px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <CalenderIcon />
                                </span>
                              </Label>
                            </div>
                          </div>
                        </div>

                        {!item["is_default"] && (
                          <div className="col-md-1">
                            <div
                              onClick={() =>
                                handleDeleteFarDetails(index, rowIndex, item?.reporting_details)
                              }
                              style={{ paddingTop: "2rem" }}
                              className="pointer"
                            >
                              <img src={RedDeleteIcon} alt="delete" />
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  }
                )}
                {hasEndDate && (
                  <div className="mt-2 asset_details_text_all_user" style={{
                    padding:"4px 7px"
                  }}>
                  {" "}
                  <span>
                    <img src={WarningIcon} alt="warning" />
                  </span>{" "}
                  Please fill in the Asset End Date to enable the Client dropdown.
                </div>
                )}
                {item["job_info"]["show_client"]?.value ? (
                  <button
                    className="btn btn-sm btn-outline pointer mt-3"
                    onClick={() => handleAddMoreFarDetails(index)}
                  >
                    {" "}
                    <PlusIconCircle /> Add More
                  </button>
                ) : null}
                
                
              </div>

              {item["job_info"]["show_client"]?.value ? null : (
                <div className="mt-2 asset_details_text_all_user">
                  {" "}
                  <span>
                    <img src={WarningIcon} alt="warning" />
                  </span>{" "}
                  Please, select client in job info to add asset details.
                </div>
              )}

              {showImagePreview && index === imagePreviewIndex && (
                <ImageModal
                  showImagePreview={showImagePreview}
                  setShowImagePreview={setShowImagePreview}
                  resetImageUrl={resetImageUrl}
                  imageDetails={imageDetails}
                  renderFilesList={renderFilesList}
                  uploadData={item?.file_attachment}
                  setUploadData={setUploadData}
                  type={"jobDetails"}
                  handleEditFileList={handleEditFileList}
                  isDelete={true}
                />
              )}
              {/* {showImagePreview && (
                <MultiFilePreviewModal
                  show={showImagePreview}
                  files={uploadData}
                  onClose={() => setShowImagePreview(false)}
                  token={token}
                  setAllFileData={setUploadData}
                />
              )} */}
              {modal ? (
                <MultipleUpload
                  modal={modal}
                  toggleModal={showUploadModal}
                  containerName={containerName}
                  handleUploadFile={handleUploadFile}
                  isDraggableModal
                  acceptedFiles="image/png, image/gif, application/pdf , image/jpeg, .csv, text/csv, application/vnd.ms-excel, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, .ppt , .pptx"
                  supportedFiles="PNG, JPEG, PDF, Excel, PPT, PPTX and Doc."
                  uploadSuccessArray={uploadSuccessArray}
                  setUploadSuccessArray={setUploadSuccessArray}
                />
              ) : null}
              {/* {modal && (
                <MultiUploadWithApi
                  modal={modal}
                  toggleModal={showUploadModal}
                  token={token}
                  handleFileChange={handleFileChange}
                  isDraggableModal
                  acceptedFiles={"image/png, image/gif, application/pdf , image/jpeg, .csv, text/csv, application/vnd.ms-excel, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, .ppt , .pptx"}
                  maxFileSize={2000000}
                  supportedFiles="PNG, JPEG, PDF, Excel, PPT, PPTX and Doc."
                  allFileData={uploadData}
                  setAllFileData={setUploadData}
                  multipleFileUploadSuccess={FileUploadSuccess}
                  dispatchResetMultipleFileUploadError={dispatchResetFileUploadError}
                  multipleFileUploadFetching={FileUploadFetching}
                  multipleFileUploadData={FileUploadData}
                  dispatchResetMultipleFileUploadSuccess={dispatchResetFileUploadSuccess}
                />
              )} */}
            </div>
          );
        }
      });
    return arr;
  };
  return <div>{renderJobDetails()}</div>;
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  FileUploadSuccess: state.clientSettings.multipleFileUploadSuccess,
  FileUploadData: state.clientSettings.multipleFileUploadData,
  FileUploadFetching: state.clientSettings.multipleFileUploadFetching,
});
const dispatchStateToProps = (dispatch: any) => ({
  dispatchResetFileUploadError: () => dispatch(resetMultipleFileUploadError()),
  dispatchResetFileUploadSuccess: () =>
    dispatch(resetMultipleFileUploadSuccess()),
  dispatchResetFileUploadFetching: () =>
    dispatch(resetMultipleFileUploadFetching()),
  dispatchResetFileUploadData: () => dispatch(resetMultipleFileUploadData()),
  dispatchUploadFilesAction: (data: StockUploadFilePayloadType) =>
    dispatch(multipleUploadFilesAction(data)),
});
export default connect(
  mapStateToProps,
  dispatchStateToProps
)(JobDetailsFormInput);
